import api from 'app/api';
import getAll from './get-places';
import getAllWithJoin from './get-places-with-join';
import addPlace from './add-place';
import editPlace from './edit-place';
import getPlaceWithDocument from './get-place-with-document';

export const placesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getPlaces: getAll(builder),
        getPlacesWithJoin: getAllWithJoin(builder),
        getPlaceWithDocument: getPlaceWithDocument(builder),
        addPlace: addPlace(builder),
        editPlace: editPlace(builder),
    }),
});

export const {
    useGetPlacesQuery,
    useGetPlacesWithJoinQuery,
    useAddPlaceMutation,
    useEditPlaceMutation,
    useGetPlaceWithDocumentQuery,
    useLazyGetPlacesQuery,
} = placesApi;
